import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import useAuth from "../../hooks/useAuth";
import BaseLayout from "../../layouts/BaseLayout";
import { BASE_URL } from "../../utils/Element";
import AddScorecardData from "./AddScorecardData";

const initialPropertyData = {
  dials_goal: "",
  conversations_goal: "",
  talk_time_goal: "",
  new_8x8s_goal: "",
  buyer_progress_goal: "",
  new_buyer_leads_goal: "",
  initial_offers_w_different_buyers_goal: "",
  seller_progress_goal: "",
  new_seller_leads_goal: "",
  new_bovs_goal: "",
  initial_offers_w_different_sellers_goal: "",
  exclusive_listings_goal: "",
  executed_loi_goal: "",
  actual_goal: "",
  gross_hopper_gains_goal: "",
  gross_commission_closed_goal: "",


};

const AddScorecard = () => {
  const navigate = useNavigate();
  const [config] = useAuth();
  const [error, setError] = useState();
  const [propertyInfo, setPropertyInfo] = useState(initialPropertyData);

  const handleClose = () => {
    setPropertyInfo(initialPropertyData);
    navigate(ROUTES.SCORECARD);
  };

  const clearError = (name) => {
    setError({ ...error, [name]: "" });
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/goals`, config)
      .then((res) => {
       const data = res?.data?.data?.goal;
   console.log("FULL RESPONSE:", data);
        setPropertyInfo({
          dials_goal: data.dials_goal,
          conversations_goal: data.conversations_goal || "",
          talk_time_goal: data.talk_time_goal || "",
          new_8x8s_goal: data.new_8x8s_goal || "",
          buyer_progress_goal: data.buyer_progress_goal || "",
          new_buyer_leads_goal: data.new_buyer_leads_goal || "",
          initial_offers_w_different_buyers_goal: data.initial_offers_w_different_buyers_goal || "",
          seller_progress_goal: data.seller_progress_goal || "",
          new_seller_leads_goal: data.new_seller_leads_goal || "",
          new_bovs_goal: data.new_bovs_goal || "",
          initial_offers_w_different_sellers_goal: data.initial_offers_w_different_sellers_goal || "",
          exclusive_listings_goal: data.exclusive_listings_goal || "",
          executed_loi_goal: data.executed_loi_goal || "",
          actual_goal: data.actual_goal || "",
          gross_hopper_gains_goal: data.gross_hopper_gains_goal || "",
          gross_commission_closed_goal: data.gross_commission_closed_goal || "",
        });
      })
      .catch((err) => {
        if (err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  }, []);


  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      dials_goal: propertyInfo.dials_goal,
      conversations_goal: propertyInfo.conversations_goal,
      talk_time_goal: propertyInfo.talk_time_goal,
      new_8x8s_goal: propertyInfo.new_8x8s_goal,
      buyer_progress_goal: propertyInfo.buyer_progress_goal,
      new_buyer_leads_goal: propertyInfo.new_buyer_leads_goal,
      initial_offers_w_different_buyers_goal: propertyInfo.initial_offers_w_different_buyers_goal,
      seller_progress_goal: propertyInfo.seller_progress_goal,
      new_seller_leads_goal: propertyInfo.new_seller_leads_goal,
      new_bovs_goal: propertyInfo.new_bovs_goal,
      initial_offers_w_different_sellers_goal: propertyInfo.initial_offers_w_different_sellers_goal,
      exclusive_listings_goal: propertyInfo.exclusive_listings_goal,
      executed_loi_goal: propertyInfo.executed_loi_goal,
      actual_goal: propertyInfo.actual_goal,
      gross_hopper_gains_goal: propertyInfo.gross_hopper_gains_goal,
      gross_commission_closed_goal: propertyInfo.gross_commission_closed_goal,
    };
    axios
      .post(`${BASE_URL}/goals`, payload, config)
      .then((res) => {
        if (res?.data?.message) {
          NotificationManager.success(res?.data?.message);
        }
        setPropertyInfo(initialPropertyData);
        navigate(ROUTES.SCORECARD);
      })
      .catch((error) => {
        if (error.response?.data?.message) {
          NotificationManager.error(error.response?.data?.message);
        }
        setError(error?.response?.data?.errors);
      });
  };

  return (
    <BaseLayout>
      <div className="contact-header">
        <p className="head-1 dark-H md:px-0 px-3">Add Scorecard Goals</p>
      </div>

      <AddScorecardData
        error={error}
        propertyInfo={propertyInfo}
        onSetFormData={(value) => {
          setPropertyInfo(value);
        }}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        clearError={clearError}
      />
    </BaseLayout>
  );
};

export default AddScorecard;
